import { render, staticRenderFns } from "./Re-Order.vue?vue&type=template&id=c8857826&scoped=true&"
import script from "./Re-Order.vue?vue&type=script&lang=js&"
export * from "./Re-Order.vue?vue&type=script&lang=js&"
import style0 from "./Re-Order.vue?vue&type=style&index=0&id=c8857826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8857826",
  null
  
)

export default component.exports